import NotificationsIcon from "@mui/icons-material/Notifications";
import Badge from "@mui/material/Badge";

import { useNotificationCount } from "~components/Notifications/api/notifications.ts";

export function NotificationsBadge({
  children,
}: {
  children: React.ReactNode;
}) {
  const { data: count, isLoading } = useNotificationCount();

  if (isLoading || !count) {
    return <>{children}</>;
  }

  return (
    <Badge badgeContent={count} color="error">
      {children}
    </Badge>
  );
}

export function NotificationsBell() {
  return (
    <NotificationsBadge>
      <NotificationsIcon />
    </NotificationsBadge>
  );
}
